<template>
  <aside id="SiteNavigation">
    <MenuButton/>
    <router-link :to="{name: 'Homepage', params: { lang: $route.params.lang } }">
      <header>
        {{$t('nav.title')}}
      </header>
    </router-link>
    <nav class="site-nav--primary">
      <ShareButtons v-if="$root.shareOpen"/>

      <ul v-if="!$root.shareOpen">
        <li class="list-heading">{{$t('nav.chapters_heading')}}</li>
        <li class="nochildren">
          <router-link :to="{name: 'Homepage', params: { lang: $route.params.lang} }">{{$t('nav.Homepage')}}</router-link>
        </li>
        <li :class="{active: $root.currentSubMenu === 'introduction'}">
          <a href="javascript:void(0)" :class="{active: routes['introduction'].indexOf($route.name) !== -1}"
            @click="openSub('introduction')">{{$t('nav.Introduction')}}</a>
          <NavSubmenu name="introduction" :routes="routes['introduction']"/>
        </li>
        <li :class="{active: $root.currentSubMenu === 'sustainable-solutions'}">
          <a href="javascript:void(0)" :class="{active: routes['sustainable-solutions'].indexOf($route.name) !== -1}"
            @click="openSub('sustainable-solutions')">{{$t('nav.SustainableSolutions')}}</a>
          <NavSubmenu name="sustainable-solutions" :routes="routes['sustainable-solutions']"/>
        </li>
        <li :class="{active: $root.currentSubMenu === 'our-customers'}">
          <a href="javascript:void(0)" :class="{active: routes['our-customers'].indexOf($route.name) !== -1}"
            @click="openSub('our-customers')">{{$t('nav.OurCustomers')}}</a>
          <NavSubmenu name="our-customers" :routes="routes['our-customers']"/>
        </li>
        <li :class="{active: $root.currentSubMenu === 'our-people'}">
          <a href="javascript:void(0)" :class="{active: routes['our-people'].indexOf($route.name) !== -1}"
            @click="openSub('our-people')">{{$t('nav.OurPeople')}}</a>
          <NavSubmenu name="our-people" :routes="routes['our-people']"/>
        </li>
        <li :class="{active: $root.currentSubMenu === 'outreach'}">
          <a href="javascript:void(0)" :class="{active: routes['outreach'].indexOf($route.name) !== -1}"
            @click="openSub('outreach')">{{$t('nav.Outreach')}}</a>
          <NavSubmenu name="outreach" :routes="routes['outreach']"/>
        </li>
        <li :class="{active: $root.currentSubMenu === 'company-performance'}">
          <a href="javascript:void(0)" :class="{active: routes['company-performance'].indexOf($route.name) !== -1}"
            @click="openSub('company-performance')">{{$t('nav.CompanyPerformance')}}</a>
          <NavSubmenu name="company-performance" :routes="routes['company-performance']"/>
        </li>
        <li :class="{active: $root.currentSubMenu === 'looking-ahead'}">
          <a href="javascript:void(0)" :class="{active: routes['looking-ahead'].indexOf($route.name) !== -1}"
            @click="openSub('looking-ahead')">{{$t('nav.LookingAhead')}}</a>
          <NavSubmenu name="looking-ahead" :routes="routes['looking-ahead']"/>
        </li>
      </ul>
    </nav>
    <NavSecondary :routes="routes"/>
    <SocialButtons/>
    <LanguageSelector />
  </aside>
</template>

<script>
import LanguageSelector from './LanguageSelector'
import MenuButton from './MenuButton'
import SocialButtons from './SocialButtons'
import NavSubmenu from './NavSubmenu'
import NavSecondary from './NavSecondary'
import ShareButtons from './ShareButtons'

export default {
  name: 'SiteNavigation',
  components: {
    LanguageSelector,
    MenuButton,
    SocialButtons,
    NavSubmenu,
    NavSecondary,
    ShareButtons
  },
  data: () => ({
    currentSub: null,
    routes: {
      'introduction': [
        'Introduction_Welcome',
        'Introduction_SustainabilityAtSchneiderElectric',
        'Introduction_WorkIndex',
        'Introduction_EnvironmentalStrategy'
      ],
      'sustainable-solutions': [
        'SustainableSolutions_Overview',
        'SustainableSolutions_Ecostruxure',
        'SustainableSolutions_EnergyServices',
        'SustainableSolutions_Research',
        'SustainableSolutions_EnergyUniversity',
        'SustainableSolutions_SupplyChain'
      ],
      'our-customers': [
        'OurCustomers_Overview',
        'OurCustomers_Building',
        'OurCustomers_DataCenter',
        'OurCustomers_Industry',
        'OurCustomers_Infrastructure'
      ],
      'our-people': [
        'OurPeople_Overview',
        'OurPeople_CompanyValues',
        'OurPeople_CompanyPrograms',
        'OurPeople_InvestmentForGrowth',
        'OurPeople_LiveLivesBetter'
      ],
      'outreach': [
        'Outreach_Overview',
        'Outreach_AccessToEnergy',
        'Outreach_SchneiderElectricFoundation'
      ],
      'company-performance': [
        'CompanyPerformance_Overview',
        'CompanyPerformance_YearInReview',
        'CompanyPerformance_20152017PlanetSocietyBarometer',
        'CompanyPerformance_Leadership',
        'CompanyPerformance_Ethics'
      ],
      'looking-ahead': [
        'LookingAhead_Overview',
        'LookingAhead_2018Priorities',
        'LookingAhead_SustainabilityApproach',
        'LookingAhead_About'
      ]
    }
  }),
  methods: {
    openSub (subMenu) {
      if (this.$root.currentSubMenu === subMenu) {
        this.$root.currentSubMenu = null
      } else {
        this.$root.currentSubMenu = subMenu
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/vars';
@import '../scss/mixins';

#app {
  &.menu-opened {
    #SiteNavigation {
      transform: translate(0, 0);
    }
  }
}
#SiteNavigation {
  @media(min-width: $screen-sm-min) {
    height: 100%;
    top: 0;
    width: $sidenav-width;
    transform: translate(-$sidenav-width, 0);
  }
  width: 100%;
  transform: translate(-100%, 0);
  height: calc(100% - 84px);
  top: 83px;
  position: fixed;
  left: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  color: #7A7A7A;
  transition: .4s transform;
  .menu-button {
    display: none; // Don't show on mobile, we use a different button there (in the header)
    @media(min-width: $screen-sm-min) {
      display: flex;
      position: absolute;
      right: -60px;
      top: 0;
      border-bottom-right-radius: 10px;
      width: 60px;
      height: 50px;
    }
  }
  header {
    display: none;
    @media(min-width: $screen-sm-min) {
      display: block;
      background: $green-light;
      color: $white;
      font-size: px2rem(14);
      line-height: px2rem(22);
      padding: 50px 24px 24px 24px;
    }
  }
}
.site-nav--primary {
  width: 100%;
  @media(min-width: $screen-sm-min) {
    width: $sidenav-width;
  }
  left: 0;
  top: 0;
  background: $white;
  flex: 1;
  overflow-y: auto;
  > ul {
    margin: 24px 0 0 0;
  }
  ul {
    padding: 0;
    list-style: none;
    // margin: 24px 0 0 0;
    > li {
      transition: .2s color, .2s background;
      font-size: 13px;
      line-height: 21px;
      font-weight: 500;
      margin: 0;
      // margin: 24px 0 0 0;
      &.list-heading {
        display: none;
        @media(min-width: $screen-sm-min) {
          display: block;
        }
        font-size: px2rem(10);
        color: $grey;
        text-transform: uppercase;
        border-bottom: 1px solid rgba(51, 51, 51, .12);
        opacity: 1;
        margin: 16px 22px;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 5px;
      }
      &.active {
        &::after {
          content: '-';
        }
        @media(min-width: $screen-sm-min) {
          background: #e7e6e6;
          color: $darker-grey;
        }
      }
      &.nochildren::after {
        display: none;
      }
      &::after {
        @media(min-width: $screen-sm-min) {
          display: none;
        }
        content: '+';
        position: absolute;
        right: 30px;
        top: 13px;
        display: block;
        font-size: px2rem(20);
        font-weight: 300;
      }
      position: relative;
      color: #7A7A7A;
      font-size: px2rem(13);
      a {
        color: inherit;
        text-decoration: none;
        display: block; // Makes it easier to tap/click
        padding: 12px 34px;
        padding-right: 40px;
        position: relative;
        @include activeLinkIndicator(11px, 18px);
        @media(min-width: $screen-sm-min) {
          padding: 14px 24px;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SiteNavigation.vue